const stylesLoader = {
  containerLoader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "200px",
  }
}

export default stylesLoader;
